import React from 'react';

import {
  IFileBoxProps,
  IFileResponse,
} from 'interfaces/IpfsHashList/FileListing';
import FileImg from 'public/assets/file.svg';

const FileBox = ({ item, getFiles, getFIlePreviewLink }: IFileBoxProps) => {
  const handleClick = (fileName: IFileResponse) => {
    if (fileName.type === 'dir') {
      getFiles(fileName.path);
    } else {
      getFIlePreviewLink(fileName.path);
    }
  };
  return (
    <div
      className=" p-2 border cursor-pointer border-[#DEDEDE] rounded-md mt-4 flex truncate ml-6 mr-6"
      onClick={() => handleClick(item)}
    >
      <img className="mr-1" src={FileImg.src} alt="" />
      <> {item.name}</>
    </div>
  );
};
export default FileBox;
